import styled from 'styled-components';
import { errorColor, grey } from '~theme';

const TextInput = props => (
  <StyledInput
    type="text"
    className="form-control"
    maxLength="100"
    {...props}
  />
);

const StyledInput = styled.input`
  ${props => (props.error ? `border-color: ${errorColor};` : '')}
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth};` : '')}
  width: 100%;
  min-height: 42px;

  padding: 0 10px;

  border-style: solid;
  border-width: 1px;
  border-color: ${grey};
  border-radius: 4px;

  font-size: 16px;
`;

export default TextInput;
